import { FormControl, Grid, InputLabel, MenuItem, Modal, Select } from "@mui/material";
import MDBox from "../../components/MDBox";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import React, { useState } from "react";
import { newDashboardUser } from "../../api/routes";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 4,
  p: 4,
};
export default function NewUserModal({ modal, handleClose, setTrigger }) {
  const [information, setInformation] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInformation({ ...information, [name]: value });
  };

  const submit = () => {
    if (information.fullname && information.role && information.username && information.password) {
      setLoading(true);
      newDashboardUser(information, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          toast.success("کاربر جدید اضافه شد!");
          setTrigger(Math.random());
          handleClose();
        }
      });
    } else return toast.error("تمام فیلد ها را تکمیل کنید!");
  };
  return (
    <Modal open={modal.state} onClose={handleClose}>
      <MDBox sx={style}>
        <Loading loading={loading} />
        <Grid container rowGap={2} py={2} px={2}>
          <Grid item xs={12} xl={12}>
            <MDInput fullWidth value={information.fullname} name="fullname" onChange={handleChange} type="text"
                     label="نام" />
          </Grid>
          <Grid item xs={12} xl={12}>
            <FormControl fullWidth>
              <InputLabel>نوع دسترسی</InputLabel>
              <Select label="نوع دسترسی" sx={{ height: "44.3px" }} value={information.role} name="role"
                      onChange={handleChange}>
                <MenuItem value={"center"}>ادمین</MenuItem>
                <MenuItem value={"reservation"}>نوبت دهی</MenuItem>
                <MenuItem value={"reception"}>پذیرش</MenuItem>
                <MenuItem value={"notebookReservation"}>دفتر نوبت دهی</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={12}>
            <MDInput fullWidth value={information.username} name="username" onChange={handleChange} type="text"
                     label="نام کاربری" />
          </Grid>
          <Grid item xs={12} xl={12}>
            <MDInput fullWidth value={information.password} name="password" onChange={handleChange} type="text"
                     label="رمزعبور" />
          </Grid>
        </Grid>
        <MDButton onClick={submit} variant="gradient" color="success" fullWidth style={{ marginTop: 15 }}>
          ایجاد
        </MDButton>
      </MDBox>
    </Modal>
  );
}
